module.exports = __webpack_public_path__ + "844c9fe9978242249f2fcee6fdb92e0e.svg";